export default __webpack_public_path__ + "static/media/logoFooter.a894a1b7.svg";